import { useNavigate } from '@tanstack/react-router';

import { Breadcrumbs } from './breadcrumbs';

import { useLogout } from '@/auth/mutations';
import { useAuthStore } from '@/auth/store';
import { Button } from '@/components/ui/button';

export const Header = () => {
  const user = useAuthStore((s) => s.currentUser);
  const logout = useLogout();
  const navigate = useNavigate();

  const onLogout = () => {
    logout.mutate(undefined, {
      onSuccess: () => {
        void navigate({ to: '/login' });
      },
    });
  };

  return (
    <header className="flex items-center justify-between border-b border-border px-6 py-3">
      <Breadcrumbs />
      <div className="flex items-center gap-3">
        <div className="text-sm text-muted-foreground">{user?.email ?? ''}</div>
        <Button variant="outline" size="sm" onClick={onLogout} disabled={logout.isPending}>
          Выйти
        </Button>
      </div>
    </header>
  );
};
